import {
  Directive,
  ElementRef,
  HostListener
} from '@angular/core';

@Directive({
  selector: '[image]'
})
export class ImageDirective {

  constructor(
    private element: ElementRef
  ) {

  }

  @HostListener('load') onloadstart() {
    this.element.nativeElement.classList.add('loaded');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/form-media/image.directive.ts